var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.195 5.14a.667.667 0 0 1 .944-.945L12 11.057l6.86-6.862a.668.668 0 0 1 .945.944L12.943 12l6.862 6.86a.667.667 0 1 1-.944.945L12 12.943l-6.86 6.862a.667.667 0 1 1-.945-.944L11.057 12 4.195 5.14Z"
  })));
};
export default SvgClose;